import Link from 'next/link'
import { useState } from 'react'
import { X } from 'react-feather'

const TeacherStrip = () => {
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null

  return (
    <div className="bg-yellow-200 bg-opacity-25 py-3 px-4 flex items-center justify-center relative">
      <p className="text-sm text-center text-grey">
        📣 <strong>Teachers</strong> 📣 Help kids thrive with live online
        tutoring, all on your schedule.{' '}
        <Link href="/teach/">
          <a className="text-blue-300 font-600 hover:underline">Apply now</a>
        </Link>
      </p>
      <button
        className="focus:outline-none absolute right-5 text-grey-700 hover:text-grey-900"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
      >
        <X className="stroke-1" />
      </button>
    </div>
  )
}

export default TeacherStrip
